import { Component, OnInit, OnDestroy } from '@angular/core';

interface Review {
  avatar: string;
  name: string;
  content: string;
  badge: string;
  badgeImg: string;
  halfStar?: boolean;
}

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit, OnDestroy {

  readonly reviews: Review[] = [
    {
      avatar: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061314/TAS/home/Ellipse-1_kfltzg.webp',
      name: 'Antonella Pérez',
      content: 'Tuve una emergencia al llegar y me asistieron desde el primer momento. Hicieron seguimiento durante el viaje y siempre estuvieron atentos.',
      badge: 'Collet',
      badgeImg: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061313/TAS/home/Calificaci%C3%B3n_2__hrznc9.webp',
      halfStar: true,
    },
    {
      avatar: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061313/TAS/home/Ellipse-1_1__yftgia.webp',
      name: 'Elaine',
      content: 'Viajé con mi nieta, una noche tuvo fiebre y recibimos atención médica inmediata por videollamada. La evaluaron y acompañaron hasta su recuperación; el servicio fue excelente.',
      badge: 'Trustpilot',
      badgeImg: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061862/TAS/home/Calificaci%C3%B3n_3_qwwcsv.webp',
      halfStar: true,
    },
    {
      avatar: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061313/TAS/home/Ellipse-1_2__deugw5.webp',
      name: 'Juan Guerrero',
      content: 'Excelente servicio, con un equipo muy amable y siempre dispuesto a ayudar. Solucionaron mi problema de inmediato y consiguieron un médico muy rápido. Fue de gran ayuda.',
      badge: 'Trustpilot',
      badgeImg: 'https://res.cloudinary.com/pervolare-org/image/upload/v1777061862/TAS/home/Calificaci%C3%B3n_3_qwwcsv.webp',
      halfStar: true,
    },
  ];

  activeIndex = 1;
  private intervalId: any;

  get prevIndex(): number {
    return (this.activeIndex - 1 + this.reviews.length) % this.reviews.length;
  }

  get nextIndex(): number {
    return (this.activeIndex + 1) % this.reviews.length;
  }

  getSlot(i: number): string {
    if (i === this.activeIndex) return 'active';
    if (i === this.prevIndex) return 'prev';
    return 'next';
  }

  ngOnInit(): void {
    this.startAutoplay();
  }

  ngOnDestroy(): void {
    this.pauseAutoplay();
  }

  startAutoplay(): void {
    this.intervalId = setInterval(() => {
      this.activeIndex = this.nextIndex;
    }, 10000);
  }

  pauseAutoplay(): void {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}